import fp1 from "./img-05.jpg";
import fp2 from "./img-16.jpg";

const FLOOR_PLAN_KEYS = new Set([
  "./img-05.jpg",
  "./img-16.jpg",
]);

const photoModules = import.meta.glob('./img-*.jpg', { eager: true, import: 'default' }) as Record<string, string>;

export const jenstejnA02Images: string[] = Object.entries(photoModules)
  .filter(([key]) => !FLOOR_PLAN_KEYS.has(key))
  .sort(([a], [b]) => {
    const na = parseInt(a.match(/img-(\d+)/)?.[1] || "0");
    const nb = parseInt(b.match(/img-(\d+)/)?.[1] || "0");
    return na - nb;
  })
  .map(([, src]) => src);

export const jenstejnA02FloorPlans: { image: string; label: string }[] = [
  { image: fp1, label: "Půdorys 1. NP" },
  { image: fp2, label: "Půdorys 2. NP" },
];
